import React from "react";
import axios from "axios";
import { message } from "antd";

import { GetUserByIdAction , CourseSubscriptionAction} from "./UserAction";
function getSchoolPoolAction(GlobalHook) {
  GlobalHook.setGlobalLoading(true);
  axios
    .get("/api/school")
    .then(res => {
      // console.log(res.data)
      GlobalHook.setGlobalSchoolPool(res.data);
      GlobalHook.setGlobalLoading(false);
    })
    .catch(err => console.log(err));
}

// Edit the database of an exisiting school.
function EditSchoolAction(GlobalHook, schoolId, schoolUpdateData) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { schoolId, schoolUpdateData };
  const pushDataEmail = { email: schoolUpdateData.schoolAdminEmail };

  return axios
    .post("/api/school/editschooldb", pushData)
    .then(res => {
      if (!schoolUpdateData.schoolAdminEmail) {
        GlobalHook.setGlobalLoading(false);
        getSchoolPoolAction(GlobalHook);
        message.success("School updated");
        return res.data;
      }

      return axios
        .post("/api/user/getfirebaseuserbyemail", pushDataEmail)
        .then(firebaseRes => {
          const pushDataUser = { uid: firebaseRes.data.uid, schoolId: schoolId };

          return axios
            .post("/api/school/updateuserschooladmin", pushDataUser)
            .then(() => {
              GlobalHook.setGlobalLoading(false);
              getSchoolPoolAction(GlobalHook);
              message.success("School and admin updated");
            });
        })
        .catch(err => {
          GlobalHook.setGlobalLoading(false);
          getSchoolPoolAction(GlobalHook);
          message.warning("School saved but admin email was not found in Firebase");
          console.log(err);
        });
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error("Failed to update school");
      console.log(err);
      throw err;
    });
}

function CreateSchoolAction(GlobalHook, schoolData) {
  GlobalHook.setGlobalLoading(true);

  return axios
    .post("/api/school/createschool", schoolData)
    .then(res => {
      const school = res.data;

      if (!schoolData.schoolAdminEmail) {
        GlobalHook.setGlobalLoading(false);
        getSchoolPoolAction(GlobalHook);
        message.success("School created");
        return school;
      }

      return axios
        .post("/api/user/getfirebaseuserbyemail", { email: schoolData.schoolAdminEmail })
        .then(firebaseRes => {
          return axios.post("/api/school/updateuserschooladmin", {
            uid: firebaseRes.data.uid,
            schoolId: school._id,
          });
        })
        .then(() => {
          GlobalHook.setGlobalLoading(false);
          getSchoolPoolAction(GlobalHook);
          message.success("School created and admin assigned");
          return school;
        })
        .catch(err => {
          GlobalHook.setGlobalLoading(false);
          getSchoolPoolAction(GlobalHook);
          message.warning("School created but admin email was not found in Firebase");
          console.log(err);
          return school;
        });
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error(err.response?.data?.error || "Failed to create school");
      console.log(err);
      throw err;
    });
}

// The user requests registration to a school...
function AddMyNewSchoolAction(GlobalHook, userId, schoolId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { userId: userId, schoolId: schoolId };

  console.log('schrodinger', pushData)
  axios
    .post("/api/school/addmynewschool", pushData)
    .then(res => {
      console.log('takeshi', res.data)
      GlobalHook.setGlobalUser(res.data);
      localStorage.setItem("globalUser", JSON.stringify(res.data));
      // CourseSubscriptorActior(GlobalHook)
      GlobalHook.setGlobalLoading(false);
    })
    .catch(err => console.log(err));
}

// The user removes registration request or membership to a school...
function RemoveMySchoolAction(GlobalHook, schoolId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { schoolId };
  console.log('removeMySchool')
  console.log(pushData)
  axios
    .post("/api/school/removemyschool", pushData)
    .then(res => {
      GlobalHook.setGlobalUser(res.data);
      localStorage.setItem("globalUser", JSON.stringify(res.data));
      // CourseSubscriptorActior(GlobalHook)
      GlobalHook.setGlobalLoading(false);
    })
    .catch(err => console.log(err));
}


function FindStudentBySchoolAction(GlobalHook, schoolId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { schoolId };

  axios
    .post("/api/school/findstudentbyschool", pushData)
    .then(res => {
      
      GlobalHook.setGlobalMatchStudentBySchool(res.data)
      GlobalHook.setGlobalLoading(false);
      console.log(res.data)
    })
    .catch(err => console.log(err));
}

function SchoolStatusChangeAction(GlobalHook, status, userId, usedCount) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { status, userId, schoolId: GlobalHook.getGlobalUser.schoolAdminId, usedCount: usedCount};
  axios
    .post("/api/school/changestudentschoolstatusAction", pushData)
    .then(res => {
      if (res.data) {
        GlobalHook.setGlobalSchoolInfo(res.data);
      }
      window.location.reload()
      GlobalHook.setGlobalLoading(false);

    })
    .catch(err => console.log(err));
}


function GetStudentSchoolCourseAction(GlobalHook, userId, schoolCourseData) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { uid: userId, schoolId: GlobalHook.getGlobalUser.schoolAdminId };

  axios
    .post("/api/school/getstudentschoolcourse", pushData)
    .then(res => {
      GlobalHook.setGlobalLoading(false);

      var tempData = []
      // var tempObject = new Object();
      for (var item of res.data.SchoolCourseList) {
        item = schoolCourseData.filter( course => course.courseId == item._id)
        console.log('elfy')
        console.log(item)
        var tempObject = {
          key: item[0].key,
          cover: item[0].Cover,
          courseName: item[0].CourseName,
          courseId: item[0].courseId,
        }
        tempData.push(tempObject)
        console.log(item)
      }

      console.log('returnStudentClick')
      // console.log(schoolCourseData)
      console.log(tempData)

      GlobalHook.setGlobalMatchStudentCourseSchool(tempData)


    })
    .catch(err => console.log(err));
}

function getmatchschoolcourseAction(GlobalHook, schoolId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { schoolId };


  axios
    .post("/api/school/getmatchschoolcourse", pushData)
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      console.log(res.data)
      GlobalHook.setGlobalMatchCourseSchool(res.data)
    })
    .catch(err => console.log(err));
}


function AssignCourseToUserAction(GlobalHook, userUid, schoolId, courseId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { userUid, schoolId, courseId };

  console.log('pushData')
  console.log(pushData)

  return axios
    .post("/api/school/assigncoursetouser", pushData)
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      console.log(res.data)
      console.log('AssignCourseToUser')
      console.log(res.data)
      var tempData = [];
      for (var index in res.data.SchoolCourseList) {
        console.log('jajamiao',res.data)
        console.log('mcDinsey', userUid)
        console.log(GlobalHook.getGlobalMatchCourseSchool)
        var filterRes = GlobalHook.getGlobalMatchCourseSchool.filter(item => item._id == res.data.SchoolCourseList[index]._id)
        tempData[index] = { _id: res.data.SchoolCourseList[index]._id, cover:filterRes[0].courseImage, courseName:filterRes[0].courseName, courseId:filterRes[0].courseId }
      }
      GlobalHook.setGlobalMatchStudentCourseSchool(tempData)

      return res
    })
    .catch(err => console.log(err));
}


function DelCourseToUserAction(GlobalHook, userId, schoolId, courseId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { userId, schoolId, courseId };
  console.log(pushData)

  axios
    .post("/api/school/delcoursetouser", pushData)
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      console.log(res.data)
      // GlobalHook.setGlobalMatchStudentCourseSchool(res.data.SchoolCourseList)

      var tempData = [];
      for (var index in res.data.SchoolCourseList) {
        console.log('jajamiao')
        console.log(res.data)
        console.log(GlobalHook.getGlobalMatchCourseSchool)
        var filterRes = GlobalHook.getGlobalMatchCourseSchool.filter(item => item._id == res.data.SchoolCourseList[index]._id)
        tempData[index] = { _id: res.data.SchoolCourseList[index]._id, cover:filterRes[0].courseImage, courseName:filterRes[0].courseName, courseId:filterRes[0]._id }
      }
      GlobalHook.setGlobalMatchStudentCourseSchool(tempData)

    })
    .catch(err => console.log(err));
}

function getSchoolIdBySlugAction(GlobalHook, schoolSlug) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { schoolSlug };


  axios
    .post("/api/school/getschoolidbyslug", pushData)
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      console.log(res.data)
      GlobalHook.setGlobalMatchCourseSchool(res.data)
    })
    .catch(err => console.log(err));
}


function getSchoolInfoByIdAction(GlobalHook, schoolId) {

  const pushData = { schoolId };

  axios
    .post("/api/school/getschoolinfobyid", pushData)
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      console.log(res.data)
      GlobalHook.setGlobalSchoolInfo(res.data)
    })
    .catch(err => console.log(err));
}

function handleSchoolInviteAcceptAction(GlobalHook) {
  GlobalHook.setGlobalLoading(true);


  const pushData = { schoolSlug: GlobalHook.getGlobalSchoolSlug };

  axios
    .post("/api/school/getschoolidbyslug", pushData)
    .then(res => {
      if (res.data[0]) {


        const pushDataId = { schoolId: res.data[0]._id };


        axios
          .post("/api/school/addmynewschool", pushDataId)
          .then(res => {
            GlobalHook.setGlobalUser(res.data);
            localStorage.setItem("globalUser", JSON.stringify(res.data));

            window.location.href = `/school/${GlobalHook.getGlobalSchoolSlug}`
            GlobalHook.setGlobalLoading(false);
          })
          .catch(err => { console.log(err); window.location.href = "/" });
      }
    })
    .catch(err => { console.log(err); message.error("error") });



}

function DeleteStudentFromSchool(GlobalHook, userId) {
  GlobalHook.setGlobalLoading(true);
  const pushData = { userId, schoolId: GlobalHook.getGlobalUser.schoolAdminId };
  axios
    .post("/api/school/deleteStudentFromSchool", pushData)
    .then(res => {
      if (res.data.school) {
        GlobalHook.setGlobalSchoolInfo(res.data.school);
      }
      window.location.reload();
      GlobalHook.setGlobalLoading(false);
    })
    .catch(err => console.log(err));
}

function AssignSchoolTeacherAction(GlobalHook, schoolId, email) {
  GlobalHook.setGlobalLoading(true);
  return axios
    .post("/api/school/assignteacher", { schoolId, email })
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      message.success("Teacher assigned");
      return res.data;
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error(err.response?.data?.error || "Failed to assign teacher");
      throw err;
    });
}

function RemoveSchoolTeacherAction(GlobalHook, schoolId, uid) {
  GlobalHook.setGlobalLoading(true);
  return axios
    .post("/api/school/removeteacher", { schoolId, uid })
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      message.success("Teacher removed");
      return res.data;
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error(err.response?.data?.error || "Failed to remove teacher");
      throw err;
    });
}

function GetSchoolTeachersAction(schoolId) {
  return axios
    .post("/api/school/getschoolteachers", { schoolId })
    .then(res => res.data)
    .catch(err => {
      console.log(err);
      return [];
    });
}

function GetSchoolCourseProgressAction(schoolId, courseId) {
  return axios
    .post("/api/school/getschoolcourseprogress", { schoolId, courseId })
    .then(res => res.data)
    .catch(err => {
      console.log(err);
      throw err;
    });
}

function GetCoursesBySchoolIdAction(schoolId) {
  return axios
    .post("/api/school/getmatchschoolcourse", { schoolId })
    .then(res => res.data || [])
    .catch(err => {
      console.log(err);
      return [];
    });
}

function GetSchoolListAction() {
  return axios
    .get("/api/school")
    .then(res => res.data || [])
    .catch(err => {
      console.log(err);
      return [];
    });
}

function CopyCourseFromSchoolAction(GlobalHook, sourceCourseId, targetSchoolId, newCourseName) {
  GlobalHook.setGlobalLoading(true);
  return axios
    .post("/api/school/copycourse", {
      sourceCourseId,
      targetSchoolId,
      newCourseName,
    })
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      message.success("Course copied successfully");
      return res.data;
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error(
        (err.response && err.response.data && err.response.data.error) ||
          "Failed to copy course"
      );
      throw err;
    });
}

function DeleteSchoolCourseAction(GlobalHook, schoolId, courseId) {
  GlobalHook.setGlobalLoading(true);
  return axios
    .post("/api/school/deleteschoolcourse", { schoolId, courseId })
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      message.success("Course deleted");
      return res.data;
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error(
        (err.response && err.response.data && err.response.data.error) ||
          "Failed to delete course"
      );
      throw err;
    });
}

function GetSchoolCourseDeleteLogsAction(schoolId) {
  return axios
    .post("/api/school/getschoolcoursedeletelogs", { schoolId })
    .then(res => res.data || [])
    .catch(err => {
      console.log(err);
      return [];
    });
}

function UpdateSchoolCertificateAction(
  GlobalHook,
  schoolId,
  certificateBackground,
  certificateEnabled
) {
  GlobalHook.setGlobalLoading(true);
  return axios
    .post("/api/school/updatecertificate", {
      schoolId,
      certificateBackground,
      certificateEnabled,
    })
    .then(res => {
      GlobalHook.setGlobalLoading(false);
      GlobalHook.setGlobalSchoolInfo(res.data);
      message.success("Certificate settings saved");
      return res.data;
    })
    .catch(err => {
      GlobalHook.setGlobalLoading(false);
      message.error(
        (err.response && err.response.data && err.response.data.error) ||
          "Failed to save certificate"
      );
      throw err;
    });
}

function GetCertificateForCourseAction(courseId) {
  return axios
    .post("/api/school/getcertificateforcourse", { courseId })
    .then(res => res.data)
    .catch(err => {
      console.log(err);
      return {
        enabled: true,
        background:
          "https://studysabaiapp.sgp1.digitaloceanspaces.com/StudySabai%20Certificate%20Template-01-01.jpg",
        schoolName: "",
        isSchoolCourse: false,
      };
    });
}


export {
  getSchoolPoolAction,
  AddMyNewSchoolAction,
  FindStudentBySchoolAction,
  SchoolStatusChangeAction,
  GetStudentSchoolCourseAction,
  getmatchschoolcourseAction,
  AssignCourseToUserAction,
  DelCourseToUserAction,
  getSchoolIdBySlugAction,
  getSchoolInfoByIdAction,
  handleSchoolInviteAcceptAction,
  RemoveMySchoolAction,
  EditSchoolAction,
  CreateSchoolAction,
  DeleteStudentFromSchool,
  AssignSchoolTeacherAction,
  RemoveSchoolTeacherAction,
  GetSchoolTeachersAction,
  GetSchoolCourseProgressAction,
  GetCoursesBySchoolIdAction,
  GetSchoolListAction,
  CopyCourseFromSchoolAction,
  DeleteSchoolCourseAction,
  GetSchoolCourseDeleteLogsAction,
  UpdateSchoolCertificateAction,
  GetCertificateForCourseAction
}